import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { RestoreOutlined, SearchOutlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { fetchListPencapaian, fetchListSetoran } from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import FlexStart from "components/FlexStart";
import { useNavigate } from "react-router-dom";
import DetailPenggajianModal from "components/Modals/DetailPenggajianModal";
import { fetchCabang } from "state/cabangAction";
moment.locale("id");

const Pencapaian = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openDetail, setOpenDetail] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedIdCabang, setSelectedIdCabang] = useState(null);
  const [dateBegin, setDateBegin] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const { list_cabang } = useSelector((state) => state.cabang);

  const { status, message } = useSelector((state) => state.global);
  const {
    list_pencapaian,
    pagination_pencapaian,
    totals_pencapaian,
  } = useSelector((state) => state.setoran);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchFilters, setSearchFilters] = useState({});
  useEffect(() => {
    dispatch(fetchCabang());
  }, []);

  const buildPencapaianQuery = (p, lp, filters) => {
    const qs = new URLSearchParams();
    filters.id && qs.set("id", filters.id);
    filters.tanggal_awal && qs.set("tanggal_awal", filters.tanggal_awal);
    filters.tanggal_akhir && qs.set("tanggal_akhir", filters.tanggal_akhir);
    qs.set("page", p + 1);
    qs.set("limit", lp);
    return qs.toString();
  };

  useEffect(() => {
    dispatch(
      fetchListPencapaian(
        buildPencapaianQuery(page, rowsPerPage, searchFilters),
      ),
    );
  }, [dispatch, page, rowsPerPage, searchFilters]);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran());
  };

  const handleCariPencapaian = () => {
    const filters = {};

    selectedIdCabang && (filters.id = selectedIdCabang);
    dateBegin && (filters.tanggal_awal = dateBegin.format("YYYY-MM-DD"));
    dateEnd && (filters.tanggal_akhir = dateEnd.format("YYYY-MM-DD"));

    setPage(0);
    setSearchFilters(filters);
  };
  const columnsPencapaian = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
        filter: false,
        sort: false,
      },
    },
    {
      name: "nama_cab",
      label: "Setoran Toko",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "opr_list",
      label: "Nama Kasir",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "tgl_kas",
      label: "Tanggal Setoran",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD MMMM YYYY"),
      },
    },
    {
      name: "total_struk",
      label: "Jumlah Struk",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => parseInt(value),
      },
    },
    {
      name: "total_omzet_data",
      label: "Total Setoran",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    // {
    //   name: "aksi",
    //   label: "Aksi",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
    //       const status = tableMeta.rowData[5]; // Ambil ID dari kolom pertama
    //       return (
    //         <>
    //           <IconButton
    //             color="info"
    //             onClick={() => {
    //               handleSelectedData(id);
    //               setOpenDetail(true);
    //             }}
    //           >
    //             <Info />
    //           </IconButton>
    //           <IconButton
    //             color="info"
    //             onClick={() => {
    //               sessionStorage.setItem(
    //                 "dataslipgaji",
    //                 JSON.stringify(list_gaji.find((item) => item.id === id))
    //               );
    //               openSlipGaji();
    //             }}
    //           >
    //             <PrintOutlined />
    //           </IconButton>
    //         </>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    serverSide: true,
    count: pagination_pencapaian?.total ?? 0,
    page: page,
    rowsPerPageOptions: [25, 50, 75],
    rowsPerPage: rowsPerPage,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };
  const totalStruk = totals_pencapaian
    ? parseInt(totals_pencapaian.total_struk || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + parseInt(item.total_struk);
      }, 0);
  const totalOmzet = totals_pencapaian
    ? parseFloat(totals_pencapaian.total_omzet_data || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + item.total_omzet_data;
      }, 0);
  const totalOmzetCash = totals_pencapaian
    ? parseFloat(totals_pencapaian.total_omzet_kasir || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + item.total_omzet_kasir;
      }, 0);
  const totalOmzetDebit = totals_pencapaian
    ? parseFloat(totals_pencapaian.total_debit_credit || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + item.total_debit_credit;
      }, 0);
  const totalOmzetQris = totals_pencapaian
    ? parseFloat(totals_pencapaian.total_ewallet || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + item.total_ewallet;
      }, 0);
  const totalPengeluaran = totals_pencapaian
    ? parseFloat(totals_pencapaian.total_pengeluaran || 0)
    : list_pencapaian.reduce((acc, item) => {
        return acc + item.total_pengeluaran;
      }, 0);
  const SummaryRow = ({ label, value }) => (
    <Box display="flex" justifyContent="space-between" width="100%">
      <Typography variant="h6" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        {value}
      </Typography>
    </Box>
  );

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Pencapaian"
        subtitle="Daftar Pencapaian dari setiap toko cabang."
      />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={
            <>
              <FlexStart>
                <Autocomplete
                  fullWidth
                  sx={{ mt: 2, width: "200px" }}
                  options={list_cabang}
                  getOptionLabel={(option) => {
                    return `${option.id_cab} - ${option.nama_cab}`;
                  }}
                  value={
                    list_cabang.find(
                      (item) => item.id_cab === selectedIdCabang
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedIdCabang(newValue?.id_cab);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="ID Cabang" name="id_cab" />
                  )}
                />
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    sx={{ mt: 2, mx: 1 }}
                    // views={["year", "month", "day"]}
                    label="Pilih Tanggal Awal"
                    minDate={moment().subtract(5, "years").startOf("month")}
                    maxDate={moment().add(1, "month").endOf("month")}
                    value={dateBegin}
                    onChange={(value) => {
                      if (value > dateEnd) {
                        setDateBegin(value);
                        setDateEnd(value);
                      } else {
                        setDateBegin(value);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    sx={{ mt: 2 }}
                    // views={["year", "month", "day"]}
                    label="Pilih Tanggal Akhir"
                    minDate={moment().subtract(5, "years").startOf("month")}
                    maxDate={moment().add(1, "month").endOf("month")}
                    value={dateEnd}
                    onChange={(value) => {
                      if (value < dateBegin) {
                        setDateBegin(value);
                        setDateEnd(value);
                      } else {
                        setDateEnd(value);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                  />
                </LocalizationProvider>
              </FlexStart>
              <FlexStart>
                <Box>
                  <Button
                    sx={{
                      backgroundColor:
                        !selectedIdCabang && !dateBegin && !dateEnd
                          ? theme.palette.primary.light
                          : theme.palette.secondary.light,
                      color: theme.palette.background.alt,
                      fontSize: "14px",
                      fontWeight: "bold",
                      padding: "10px 20px",
                      mt: 2,
                    }}
                    onClick={() => {
                      setSelectedIdCabang(null);
                      setDateBegin(null);
                      setDateEnd(null);
                    }}
                  >
                    <RestoreOutlined sx={{ mr: "10px" }} />
                    Reset
                  </Button>
                  <Button
                    sx={{
                      backgroundColor: theme.palette.secondary.light,
                      color: theme.palette.background.alt,
                      fontSize: "14px",
                      fontWeight: "bold",
                      padding: "10px 20px",
                      "&:hover": {
                        backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
                      },
                      mt: 2,
                      mx: 1,
                    }}
                    onClick={() => handleCariPencapaian()}
                  >
                    <SearchOutlined sx={{ mr: "10px" }} />
                    Cari
                  </Button>
                </Box>
              </FlexStart>
              <br />
              <hr />
              <Typography variant="h3" fontWeight={"bold"}>
                Summary Pencapaian Omzet
              </Typography>
              <SummaryRow
                label="Total Struk:"
                value={`${parseFloat(totalStruk)} Transaksi`}
              />
              <SummaryRow
                label="Total Omzet Setoran:"
                value={formatRupiah(parseFloat(totalOmzet))}
              />
              <SummaryRow
                label="Total Omzet Setoran (Only Cash):"
                value={formatRupiah(parseFloat(totalOmzetCash))}
              />
              <SummaryRow
                label="Total Omzet Debit Credit:"
                value={formatRupiah(parseFloat(totalOmzetDebit))}
              />
              <SummaryRow
                label="Total Omzet QRIS:"
                value={formatRupiah(parseFloat(totalOmzetQris))}
              />
              <SummaryRow
                label="Total Pengeluaran:"
                value={formatRupiah(parseFloat(totalPengeluaran))}
              />
              <hr />
            </>
          }
          data={list_pencapaian}
          columns={columnsPencapaian}
          options={options}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        {/* <KonfirmasiModal
          titleType={"Setujui"}
          subtitleType={"Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleSetujui()}
          textButtonPositif={"Setujui"}
        /> */}
        <DetailPenggajianModal
          dataDetail={selectedData}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
        />
      </Box>
    </Box>
  );
};

export default Pencapaian;
